/**
 * @generated SignedSource<<7e69c10e15b7fb06c1c2972bee119a74>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TiktokGoStatus = "approved" | "pending" | "rejected";
import { FragmentRefs } from "relay-runtime";
export type SnsAssociationTiktok$data = {
  readonly profile: {
    readonly isTiktokGoCreator: boolean;
    readonly tiktokGoStatus: TiktokGoStatus;
    readonly tiktokGoUniqueId: string | null;
    readonly tiktokUrl: string | null;
  };
  readonly " $fragmentType": "SnsAssociationTiktok";
};
export type SnsAssociationTiktok$key = {
  readonly " $data"?: SnsAssociationTiktok$data;
  readonly " $fragmentSpreads": FragmentRefs<"SnsAssociationTiktok">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SnsAssociationTiktok",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InfluencerInfo",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tiktokUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isTiktokGoCreator",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tiktokGoStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "tiktokGoUniqueId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Influencer",
  "abstractKey": null
};

(node as any).hash = "a1bddc05483a4c1776e113f0efdd98af";

export default node;
